import mitt from 'mitt';
globalThis.caiEventBus ||= mitt();
globalThis.caiEventBus.once = (eventName, listener) => {
  const wrapper = event => {
    globalThis.caiEventBus.off(eventName, wrapper);
    listener(event);
  };
  return globalThis.caiEventBus.on(eventName, wrapper);
};
globalThis.caiEventBus.publish = function (eventName, data) {
  return globalThis.caiEventBus.emit(eventName, data);
};
export const eventBus = globalThis.caiEventBus;